import { createAsyncThunk } from '@reduxjs/toolkit';
import { ErrorToast, SuccessToast } from 'components/Toasts/Toasts';

import {
  getPackagesAsync,
  getUserPackagesAsync,
  purchasePackagesAsync,
  getPackagesDetailsAsync,
  cancelPaymentAsync,
} from 'requests/packages.request';

interface AddressInfo {
  firstName: string;
  lastName: string;
  address: string;
  postalCode: string;
  city: string;
  country: string;
  countryCode: string;
}

interface Order {
  packageId: number;
  currencyType: string;
  networkType: string;
  shippingInfo: AddressInfo;
  billingInfo?: AddressInfo;
  navigate: any;
}

export const getPackages = createAsyncThunk('packages', async () => {
  const data = await getPackagesAsync();

  return data.packages;
});

export const getUserPackages = createAsyncThunk(
  'packages/userPackages',
  async () => {
    const data = await getUserPackagesAsync();

    return data.userPackages;
  }
);

export const purchasePackages = createAsyncThunk(
  'packages/purchasePackages',
  async (
    {
      packageId,
      currencyType,
      networkType,
      shippingInfo,
      billingInfo,
      navigate,
    }: Order,
    { rejectWithValue }
  ) => {
    try {
      const { data } = await purchasePackagesAsync({
        packageId,
        currencyType,
        networkType,
        shippingInfo,
        billingInfo,
      });

      navigate(`/dashboard/payment-summary/${data?.userPackage?.id}`);

      return data;
    } catch (e: any) {
      ErrorToast(e.response.data.message);
      return rejectWithValue(e.response.data.error);
    }
  }
);

export const getPackagesDetails = createAsyncThunk(
  'packages/getPackagesDetails',
  async (id: number) => {
    const data = await getPackagesDetailsAsync(id);

    return data.details;
  }
);

export const cancelPayment = createAsyncThunk(
  'packages/cancelPayment',
  async (
    { id, setIsOpen }: { id: number; setIsOpen: any },
    { rejectWithValue }
  ) => {
    try {
      await cancelPaymentAsync(id);
      setIsOpen(false);
      SuccessToast('Order successfully canceled!');
      return id;
    } catch (e: any) {
      ErrorToast(e.response.data.message);
      return rejectWithValue(e.response.data.error);
    }
  }
);
